import script from "./ConfirmationRegisterObstacleRace2026.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationRegisterObstacleRace2026.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationRegisterObstacleRace2026.vue?vue&type=style&index=0&id=0a3f4931&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3f4931"]])

export default __exports__